"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const cityState_1 = __importDefault(require("./cityState"));
function locationLabelText(locationText = '', regionText = '', regionAbbrev = undefined) {
    const addRegion = locationText.match(new RegExp(regionText, 'i')) === null;
    const regionAddon = regionAbbrev || regionText;
    return (0, cityState_1.default)(locationText, addRegion ? regionAddon : '');
}
exports.default = locationLabelText;
